<template>
    <v-tooltip v-if="tooltip" bottom max-width="320">
        <template #activator="{ on, attrs }">
            <v-chip
                v-bind="chipAttrs(attrs)"
                v-on="on"
            >
                {{ statusText }}
            </v-chip>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
    <v-chip v-else v-bind="chipAttrs()">
        {{ statusText }}
    </v-chip>
</template>

<script>
import utils from "@/utils";

export default {
    name: "CustomerOrderStatusChip",
    props: {
        order: {
            type: Object,
            required: true,
        },
        small: {
            type: Boolean,
            default: true,
        },
        chipClass: {
            type: [String, Array, Object],
            default: null,
        },
        labeled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        statusText() {
            return utils.getCustomerOrderStatusText(this.order);
        },
        tooltip() {
            return utils.getCustomerOrderStatusTooltip(this.order);
        },
    },
    methods: {
        chipAttrs(activatorAttrs = {}) {
            return {
                ...activatorAttrs,
                class: this.chipClass,
                small: this.small,
                label: this.labeled,
                outlined: !!this.order.readonly,
                color: utils.getCustomerOrderStatusColor(this.order),
            };
        },
    },
};
</script>
